import { Grid } from "@mui/material";
import AcxVirtualizedSelectMulti from "components/UI/Select/AcxVirtualizedSelectMulti";
import { observer } from "mobx-react";
import React from "react";
import type ChartCardStore from "../ChartCardStore";

type ThemesControlProps = {
    store: ChartCardStore;
};

/**
 * Chart-level Theme selector for the Theme Prevalence Cards, which read the Primary Driver's
 * Theme. {@link TopicsControl} is the equivalent for the retained Cards on the Fast Reporting
 * Theme path; the two are kept separate so a Card's selection can never cross Theme contracts.
 */
const ThemesControl = observer(({ store }: ThemesControlProps) => {
    const optionsLoading = store.isRefreshing && store.themes.length === 0;

    return (
        <Grid container item xs={4}>
            <AcxVirtualizedSelectMulti
                options={store.themes}
                id={`theme-select-${store.id}`}
                onApply={(ids) => {
                    store.setSelectedId("themes", ids);
                    store.handleSelectionChange();
                }}
                itemName="Theme"
                defaultSelectedIds={
                    store.selectedIds["themes"] as string[] | undefined
                }
                labelField="themeLabel"
                idField="id"
                maxSelectionCount={store.getMaxSelection()}
                isLoading={optionsLoading}
                enableCompactLayout
                disabled={store.isReadOnly}
                disabledAppearance="readOnly"
            />
        </Grid>
    );
});

export default ThemesControl;
